export const has = (object: any, key: any) => {
  return object != null && Object.hasOwn(object, key);
};
